module.exports = __webpack_public_path__ + "img/SL-M-260-330.1555ad88.svg";